import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* CREATE */
export const createFamily = (data)=>{
  return api.post(ENDPOINTS.FAMILIES.CREATE,data);
};

/* LIST */
export const listFamilyByParams = (data)=>{
  return api.post(ENDPOINTS.FAMILIES.SEARCH,data);
};

/* GET BY ID */
export const getFamilyById = (id)=>{
  return api.get(ENDPOINTS.FAMILIES.BY_ID(id));
};

/* UPDATE */
export const updateFamily = (id,data)=>{
  return api.put(ENDPOINTS.FAMILIES.UPDATE(id),data);
};

/* DELETE */
export const deleteFamily = (id)=>{
  return api.delete(ENDPOINTS.FAMILIES.DELETE(id));
};

/* MAIN CATEGORY DROPDOWN */
export const mainCategoryDropdown = ()=>{
  return api.get(ENDPOINTS.FAMILIES.MAIN_CATEGORY_DROPDOWN);
};

export const specTypeByFamily = (family_id)=>{
  return api.get(`/api/v1/spec-types/family/${family_id}`);
};

export const familyDropdown = ()=>{
  return api.get("/api/v1/families/dropdown");
};